import {
  Container,
  DefaultPageLayout,
  getAbsoluteUrl,
  HeadMetatags,
} from 'routes/components/Layout'
import { AIHero } from './components/Hero'
import { AIContent } from './components/Content'
import { AIActions } from './components/Actions'
import classes from './HowWeUseAI.module.scss'

export default function HowWeUseAIPage() {
  return (
    <DefaultPageLayout className={classes.page}>
      <HeadMetatags
        title={'How We Use AI'}
        openGraphImageUrl={getAbsoluteUrl(
          'images/open-graph/how-we-use-ai.png',
        )}
      />
      <Container grid>
        <AIHero />
        <AIContent />
        <AIActions />
      </Container>
    </DefaultPageLayout>
  )
}
